import initSqlJs from 'sql.js';

// Import wasm as a static asset and return the emitted URL to sql.js
import sqlWasm from 'sql.js/dist/sql-wasm.wasm';
import {
  IDX_DB_SQLITE_KEY,
  getFromIdxDb,
  initIdxDb,
  putToIdxDb,
} from './indexedDb.web';
import {
  initTablesAndData,
  initTimestampData,
  parseMigrationTextContent,
  parseTextContent,
} from './init';
import {checkOtherMigrations, initVersionsTable, isMigrationApplied} from './versions';

// without return value
export const runSqlCmd = async (tx, cmd) => {
  try {
    tx.run(cmd);
  } catch (e) {
    console.log(e);
  }
};

export const txExec = async (tx, cmds) => {
  if (!Array.isArray(cmds)) {
    if (cmds){
      const txCmd = `BEGIN TRANSACTION; ${cmds} COMMIT;`;
      return await runSqlCmd(tx, txCmd);
    }
  } else {
    for (let cmd of cmds) {
      if (cmd){
        const cmdString = cmd.join(' ');
        const txCmd = `BEGIN TRANSACTION; ${cmdString} COMMIT;`;
        await runSqlCmd(tx, txCmd);
      }
    }
  }
};

// with return
export const execSqlCmd = async (tx, cmd) => {
  try {
    return tx.exec(cmd);
  } catch (e) {
    console.log(e);
  }
  return null;
};

export const execSqlCmdThrowable = async (tx, cmd) => {
  return tx.exec(cmd);
};

export const parseSqlResults = (sqlResults, parsedResults) => {
  if (sqlResults) {
    sqlResults.forEach(result => {
      const dataColumns = result['columns'];
      const dataSets = result['values'];
      dataSets.forEach(dataSet => {
        let counter = 0;
        const out = {};
        dataSet.forEach(data => {
          out[dataColumns[counter]] = data;
          counter++;
        });
        parsedResults.push(out);
      });
    });
  }
  return parsedResults;
};

export const parseSqlExistsResults = sqlResults => {
  if (!Array.isArray(sqlResults) || !sqlResults.length) {
    // array does not exist, is not an array, or is empty
    // ⇒ do not attempt to process array
    return false;
  }
  return true;
};

export const parseSqlCountResults = sqlResults => {
  if (sqlResults) {
    for (let result of sqlResults) {
      const res = result?.['values']?.[0] ?? 0;
      return Array.isArray(res) ? res[0] : res;
    }
  }
  return 0;
};

const fetchDbFile = async filename => {
  let out = {};
  try {
    const res = await fetch(filename);
    const text = await res.text();
    if (text) {
      if (filename === TIMESTAMPS_DB_FILENAME) {
        out = parseMigrationTextContent(text);
      } else {
        out = parseTextContent(text);
      }
    }
  } catch (e) {
    console.log(e);
  }
  return out;
};

export const MAIN_DB_FILE = 'db.sql.txt';
export const TIMESTAMPS_DB_FILENAME = 'verseTimestamps.sql';
export const initDb = async (db, FORCE_DB_CREATE) => {
  try {
    console.log('Trying to init DB: ' + db);
    if (!db) {
      await initIdxDb();
      const SQL = await initSqlJs({locateFile: () => sqlWasm});
      const restoredDb = await importDatabase();
      db = restoredDb ? new SQL.Database(restoredDb) : new SQL.Database();
      await initVersionsTable(db);
      const isInitDataLoaded = await isMigrationApplied(2, db);
      if (!isInitDataLoaded || FORCE_DB_CREATE) {
        const dbContent = await fetchDbFile(MAIN_DB_FILE);
        if (dbContent) {
          await initTablesAndData(db, dbContent);
        }
      }
      await checkOtherMigrations(db);
      /*
      const migrationApplied = await checkOtherMigrations(db);
      if (migrationApplied.includes(4)) {
        // TODO: this migration takes extremely long, should be merged to main db
        const dbContent = await fetchDbFile(TIMESTAMPS_DB_FILENAME);
        if (dbContent) {
          await initTimestampData(db, dbContent, 9);
        }
      }
      */
      exportDatabase(db);
      return db;
    }
  } catch (e) {
    console.log('Database init error');
    console.log(e);
  }
  return db;
};

export const exportDatabase = async db => {
  //console.log('Trying to export database');
  await putToIdxDb(IDX_DB_SQLITE_KEY, db.export());
};

export const importDatabase = async () => {
  console.log('Trying to import database');
  const dbContent = await getFromIdxDb(IDX_DB_SQLITE_KEY);
  return dbContent;
};
